import { render } from "./MenuItem.vue?vue&type=template&id=908e9426"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=908e9426&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__